'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Select = require('calcite-react/Select');

var _Select2 = _interopRequireDefault(_Select);

var _Menu = require('calcite-react/Menu');

var _ValueInput = require('../components/ValueInput');

var _ValueInput2 = _interopRequireDefault(_ValueInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RelativeDateChooser = function (_Component) {
  _inherits(RelativeDateChooser, _Component);

  function RelativeDateChooser(props) {
    _classCallCheck(this, RelativeDateChooser);

    var _this = _possibleConstructorReturn(this, (RelativeDateChooser.__proto__ || Object.getPrototypeOf(RelativeDateChooser)).call(this, props));

    _this.handleNumberValueChange = function (e) {
      _this.setState({
        value: _extends({}, _this.state.value, {
          timeSizeValue: Number(e.code)
        })
      }, function () {
        return _this.props.onChange(_this.state.value);
      });
    };

    _this.handleSelectOptionChange = function (e) {
      _this.setState({
        value: _extends({}, _this.state.value, {
          timeSpanValue: e
        })
      }, function () {
        return _this.props.onChange(_this.state.value);
      });
    };

    _this.state = {
      value: {
        timeSizeValue: 1,
        timeSpanValue: 'days'
      }
    };
    return _this;
  }

  _createClass(RelativeDateChooser, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var timeSizeValue = this.props.value.timeSizeValue || this.state.value.timeSizeValue;
      var timeSpanValue = this.props.value.timeSpanValue || this.state.value.timeSpanValue;

      this.setState({
        value: {
          timeSizeValue: Number(timeSizeValue),
          timeSpanValue: timeSpanValue
        }
      }, function () {
        return _this2.props.onChange(_this2.state.value);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { style: { display: 'inline-flex' } },
        _react2.default.createElement(_ValueInput2.default, {
          style: style.valueInput,
          value: this.state.value.timeSizeValue,
          type: 'number',
          onChange: this.handleNumberValueChange
        }),
        _react2.default.createElement(
          _Select2.default,
          {
            style: style.selectInput,
            selectedValue: this.state.value.timeSpanValue,
            onChange: this.handleSelectOptionChange
          },
          _react2.default.createElement(
            _Menu.MenuItem,
            { value: 'minutes' },
            'minute(s)'
          ),
          _react2.default.createElement(
            _Menu.MenuItem,
            { value: 'hours' },
            'hour(s)'
          ),
          _react2.default.createElement(
            _Menu.MenuItem,
            { value: 'days' },
            'day(s)'
          ),
          _react2.default.createElement(
            _Menu.MenuItem,
            { value: 'weeks' },
            'week(s)'
          ),
          _react2.default.createElement(
            _Menu.MenuItem,
            { value: 'months' },
            'month(s)'
          ),
          _react2.default.createElement(
            _Menu.MenuItem,
            { value: 'years' },
            'year(s)'
          )
        )
      );
    }
  }]);

  return RelativeDateChooser;
}(_react.Component);

var style = {
  valueInput: {
    // overrides here?
  },
  selectInput: {
    // overrides here?
  }
};

exports.default = RelativeDateChooser;


//////////////////
// WEBPACK FOOTER
// ./node_modules/arcgis-filter/dist/components/RelativeDateChooser.js
// module id = 1624
// module chunks = 0